// extracted by mini-css-extract-plugin
module.exports = {"autoText":"_3ShVHiQCjegOdtTXfrZvh7"};